<template>
   <div class="container d-flex flex-column" tabindex="0">
    <Logged-user />
    <div class="row loader" v-if="loading">
      <div class="col align-self-center text-center ">
        <square-loader />
      </div>
    </div>
    <div class="row mt-4" v-else>
      <div class="col-md-4">
        <div class="card">
          <div class="card-header">
            <div class="row justify-content-between">
              <span class="col game-title">{{game.gameName}}</span>
              <span class="col-auto text-right creator">{{game.creator}}</span>
            </div>
          </div>
          <div class="card-body">
            <div>
              <div class="row">
                <span class="col">Début :</span>
                <span class="col-auto">
                  En attente</span>
              </div>
              <div class="row">
                <span class="col">Joueurs :</span>
                <span class="col-auto">{{players.length}}
                  <img src="/static/people.svg" height="24"/></span>
              </div>
              <div class="row" v-if="game.roundTime">
                <span class="col">Temps par tour :</span>
                <span class="col-auto">{{roundTime}}
                  <img src="/static/alarm.svg" height="18"/></span>
              </div>
              <div class="row">
                <span class="col">Joueurs :</span>
              </div>
              <div class="row player-list">
                <div class="col-12">
                  <ul class="list-group list-group-flush">
                    <li v-for="(player, index) in players" v-bind:key="index"
                      class="list-group-item">
                      <img v-bind:src="player.picture" width="30"/>
                      {{player.username}}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-8">
        <div class="row">
          <div class="col-12">
            <GameChatStomp v-bind:gameId="activeGameId"></GameChatStomp>
          </div>
        </div>
        <div class="row mt-4" v-if="isCreator">
          <div class="col-6">
            <button class="btn btn-link" v-on:click="startGame">
              LANCER LA PARTIE
            </button>
          </div>
          <div class="col-6">
            <button class="btn btn-link" v-on:click="deleteGame">
              SUPPRIMER LA PARTIE
            </button>
          </div>
        </div>
        <div class="row mt-4" v-else>
          <div class="col-6">
            Il vous suffit d'attendre que le créateur lance la partie.
          </div>
          <div class="col-6 text-right">
            <button class="btn btn-link" v-on:click="leave">
              ABANDONNER
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-auto">
      <div class="mt-4">
      <bottom-nav />
      </div>
    </div>
  </div>
</template>

<script>
import iam from '../../iam';
import SquareLoader from '../SquareLoader';
import LoggedUser from '../LoggedUser';
import BottomNav from '../BottomNav';
import GameChatStomp from './GameChatStomp';

export default {
  name: 'PrepareGame',
  components: {
    SquareLoader,
    LoggedUser,
    BottomNav,
    GameChatStomp,
  },
  props: {
    activeGameId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      game: undefined,
      timeout: undefined,
    };
  },
  created() {
    this.updateInfo(this.activeGameId);
  },
  beforeDestroy() {
    clearTimeout(this.timeout);
  },
  computed: {
    roundTime() {
      if (this.game.roundTime < 120) {
        return `${this.game.roundTime} s`;
      }
      return `${this.game.roundTime / 60} min`;
    },
    isCreator() {
      return iam.getConnectedUser().username === this.game.creator;
    },
  },
  methods: {
    updateInfo(activeGameId) {
      return Promise.all([
        this.findGameById(activeGameId),
        this.findPlayers(activeGameId)])
        .then(([game, players]) => {
          this.game = game;
          this.players = players;
          if (this.game.startDate) {
            this.$router.push(`/games/${this.game.id}`);
          } else {
            this.timeout = setTimeout(() => this.updateInfo(activeGameId), 8000);
            this.loading = false;
          }
        });
    },
    findGameById(activeGameId) {
      return this.$http.get(`${process.env.LCT_API_URL}/active-games/${activeGameId}`)
        .then(response => response.data);
    },
    findPlayers(activeGameId) {
      return this.$http.get(`${process.env.LCT_API_URL}/game-players?activeGameId=${activeGameId}`)
        .then(response => response.data);
    },
    leave() {
      const gamePlayerId = sessionStorage.getItem(`${this.game.id}`);
      if (!gamePlayerId) {
        this.$router.push('/lobby');
        return;
      }
      this.$http.delete(`${process.env.LCT_API_URL}/game-players/${gamePlayerId}`)
        .then(() => {
          sessionStorage.removeItem(`${this.game.id}`);
          this.$router.push('/lobby');
        });
    },
    deleteGame() {
      this.$http.delete(`${process.env.LCT_API_URL}/active-games/${this.game.id}`)
        .then(() => {
          sessionStorage.removeItem(`${this.game.id}`);
          this.$router.push('/lobby');
        });
    },
    startGame() {
      this.$http.put(`${process.env.LCT_API_URL}/active-games/${this.game.id}`, {
        ...this.game,
        startIn: 20,
      }).then(() => {
        this.$router.push(`/games/${this.game.id}`);
      });
    },
  },
};
</script>

<style scoped>
.player-list ul{
  list-style-type: none;
  height: 290px;
  overflow-y: scroll;
  margin: 4px 0 0 0;
}
.player-list ul .list-group-item {
  padding-top: 4px;
  padding-bottom: 4px;
}
.btn-link {
  color: #CE0F69;
}

</style>



// WEBPACK FOOTER //
// src/components/games/PrepareGame.vue